import { render, staticRenderFns } from "./CommentEditor.vue?vue&type=template&id=67d20d06&"
import script from "./CommentEditor.vue?vue&type=script&lang=ts&"
export * from "./CommentEditor.vue?vue&type=script&lang=ts&"
import style0 from "./CommentEditor.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports